import classNames from 'classnames'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import './context-chip.styles.scss'
import type { IContextChip } from './context-chip.types'

export function ContextChipView({ children, icon, isActive, className, onClose, onClick }: IContextChip) {
  const t = useTranslate()

  return (
    <button
      className={classNames('context-chip', className, {
        'with-icon': icon,
        'with-close': onClose,
        active: isActive,
      })}
      onClick={onClick}
    >
      {icon}
      {children}
      {onClose && (
        <button
          type="button"
          className="close-button"
          aria-label={t(TOLGEE_GLOBALS.remove)}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation()
            onClose()
          }}
        >
          <Icon icon="smallClose" fill="var(--color_neutral_800)" />
        </button>
      )}
    </button>
  )
}
